import React, { useEffect, useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import * as actions from '../../../store/actions'
import { connect } from "react-redux";
import { onChangeInput, validateEmail, validateInputs, validatePassword } from "../../../services/utils";
import { useStyles } from './styles'
import Loader from "../../../components/loading";
import Alert from "../../../components/alert";
import { finance } from "../../../assets/images/img/index";
import { rockLogo } from '../../../assets/images/img/index';
import InputRow from "../../../components/inputComponents/inputRow";
import PrimaryButton from "../../../components/primaryButton/primaryButton";
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Link from '@material-ui/core/Link';

import './style.scss'

const ForgotPassword = (props) => {
  const classes = useStyles();
  const [state, setState] = useState({
    values: {
      email: "",
    },
    errors: {
      email: "",

    },
  });

  useEffect(() => {
    const { error, success } = props.authReducer;
    if (error) {
      setTimeout(() => {
        props.errorHandlerSuccess();
      }, 1500);
    } else {
      if (success) {
        setTimeout(() => {
          props.errorHandlerSuccess();
        }, 1000);
        props.history.push("/verifyPassword");
      }
    }
  }, [props.authReducer.error, props.authReducer.user, props.authReducer.success, props.authReducer.loading]);
  const { values, errors } = state;

  const forgotPassword = (e) => {
    e.preventDefault();
    
    let { email } = values;
    const data = { email }
    let recordedErrors = validateInputs(data);
    if (Object.keys(recordedErrors).length > 0) {
      console.log(recordedErrors)
      setState((prevState) => ({
        ...prevState,
        errors: recordedErrors,
      }));
    } else {
      let recordedErrors = { }
      if (!validateEmail(email)) {
        recordedErrors.email = 'Invalid Email';
      }
      if (Object.keys(recordedErrors).length > 0) {
        setState((prevState) => ({
          ...prevState,
          errors: recordedErrors,
        }));
      } else {
        const data = { email };
        props.onForgotPasswordHandler(data);
      }
    }
  };
  const { authReducer: { error, success, loading } } = props;

  return (
    <Grid container component="main" className={classes.root}>

      <Grid container alignItems='center' xs={12} sm={12} md={12} lg={12} component={Paper} elevation={6} square className={'login-page-image-sec'}>
        <span className='logn-logo'>
          <img src={rockLogo} />
        </span>
        <div className={classes.loginPage} >
          {/* <Avatar className={classes.avatar}> <LockOutlinedIcon/> </Avatar> */}

          <Grid container className='containerflix-column login-mg'>
            <h4>CP-RRP</h4>
            <h2>Forgot your password?</h2>
            {/* <Typography component="h5" variant="h5"> <span>Login</span> </Typography> */}
            <p className='paragraph-login'>Enter your email address to retrieve your password </p>
          </Grid>
          {/*<input type='text' inputMode='url'/>*/}
          <Grid container xs={12} direction={'column'} alignItems={"center"} justify={"center"}>
            {((error || success) && !loading) && <Alert type={error ? 'error' : 'success'} message={error || success} />}
            <div className='makeStyles-formLogin-5'>
              <form className={classes.formLogin}>
                <InputRow
                  types={[
                    // { type: 'text', value: values.email, error: errors.email, label: 'email', id: 'email' },
                    { type: 'text', value: values.email, error: errors.email, label: 'email', id: 'email' },
                  ]}
                  onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                  numOfInputPerRow={1}
                />

                <Grid container className='mt-5 mb-20 align-self-start link-login'>
                  {props.authReducer.loading ?
                    <Loader /> :
                    <PrimaryButton value={'submit'} onClick={forgotPassword} />
                  }
                </Grid>
              </form>
            </div>
          </Grid>
        </div>
      </Grid >
      <Link href='mailto:cpreports@rockvillegroup.com'>
        <h5 className='contact_us'>Contact Us
          <Tooltip title="cpreports@rockvillegroup.com" placement='top-start' arrow>
            <ContactSupportIcon fontSize='small' className='contact_icon' />
          </Tooltip>
        </h5>
      </Link>
      {/* <Link href=''>
        
      </Link> */}

    </Grid >
  );
}

const mapStateToProps = ({ authReducer }) => {
  return { authReducer };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onForgotPasswordHandler: (data) => dispatch(actions.forgotPasswordStart(data)),
    errorHandlerSuccess: () => dispatch(actions.loginErrorHandlerSuccess()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);